<template>
  <div>
    <div class="five_step_box mb-20" v-if="true">
      <fiveStep :step="3" :wrongProgres="knowledgeCountInfo.knowledgePercentage"></fiveStep>
    </div>
    <div class="exercise_consolidation p-20">
      <div class="flex FlexBetween Flexalign">
        <div class="exercise-title">· 错题分析</div>
        <div class="flex Flexalign">
          <div class="btn_previous btn_next cursor_pointer" @click="previoustep">
            上一步
          </div>
          <div class="btn_next ml-20 cursor_pointer" @click="nextStep">
            下一步
          </div>
        </div>
      </div>
      <div class="homework_difficult flex Flexalign mt-20">
        <div class="line_green"></div>
        <div class="difficult_text ml-8">阶段分析</div>
      </div>
      <div class="stage_analysis mt-20 flex Flexalign FlexBetween">
        <div class="stage_one flex Flexalign">
          <el-image class="knowledge_total ml-10" :src="iconPath('knowledge_total.png')"></el-image>
          <div class="stage_info ml-20 FlexBetween flex flexcolumn">
            <div>知识点数</div>
            <div class="stage_value">
              {{ knowledgeCountInfo.knowledgeCount }}
            </div>
          </div>
        </div>
        <div class="stage_one flex Flexalign">
          <el-image class="knowledge_total ml-10" :src="iconPath('control_rate.png')"></el-image>
          <div class="stage_info ml-20 FlexBetween flex flexcolumn">
            <div>知识点掌握率</div>
            <div class="stage_value">
              {{ knowledgeCountInfo.knowledgePercentage }}
              <span class="stage_unit">%</span>
            </div>
          </div>
        </div>
      </div>
      <div class="homework_difficult flex Flexalign mt-30">
        <div class="line_green"></div>
        <div class="difficult_text ml-8">习题巩固</div>
      </div>
      <div class="practice_consolidate mt-20 flex Flexalign FlexBetween">
        <div class="practice_consolidate_one flex flexcolumn Flexalign cursor_pointer Flexjustify"
          @click="goWrongConsolidate">
          <el-image class="exercise_consolidation_icon1" :src="iconPath('exercise_consolidation_icon2.png')"></el-image>
          <div>错题巩固</div>
        </div>
        <div class="practice_consolidate_one flex flexcolumn Flexalign cursor_pointer Flexjustify"
          @click="goClassicsWrongConsolidate">
          <el-image class="exercise_consolidation_icon1" :src="iconPath('exercise_consolidation_icon3.png')"></el-image>
          <div>经典错题</div>
        </div>
        <div class="practice_consolidate_one flex flexcolumn Flexalign cursor_pointer Flexjustify"
          @click="goWrongReflect">
          <el-image class="exercise_consolidation_icon1" :src="iconPath('exercise_consolidation_icon1.png')"></el-image>
          <div>错题反思</div>
        </div>
        <!-- <div class="consolidate_one" @click="goWrongConsolidate">
          <el-image class="wrong_box_bg" :src="iconPath('wrong_box_bg.png')"></el-image>
          <div class="flex Flexalign consolidate_one_info cursor_pointer">
            <div>错题巩固</div>
            <el-image class="next_page ml-10" :src="iconPath('next_page.png')"></el-image>
          </div>
          <div class="mt-15 toverflows toverflow2 consolidate_text">
            错题巩固剖析错因，定期复盘，化错为梯，提升学习能力。
          </div>
        </div>
        <div class="consolidate_one cursor_pointer" @click="goClassicsWrongConsolidate">
          <el-image class="wrong_box_bg" :src="iconPath('wrong_box_bg.png')"></el-image>
          <div class="flex Flexalign consolidate_one_info">
            <div>经典错题</div>
            <el-image class="next_page ml-10" :src="iconPath('next_page.png')"></el-image>
          </div>
          <div class="mt-15 toverflows toverflow2 consolidate_text">
            经典错题是知识漏洞的 “信号灯”，剖析错因、反复推演，助你精准补漏、提升思维。
          </div>
        </div> -->
      </div>
      <div class="homework_difficult flex Flexalign mt-20">
        <div class="line_green"></div>
        <div class="difficult_text ml-8">知识点掌握情况</div>
      </div>
      <div v-show="isShowKnowledgeGraph">
        <!-- 知识图谱 -->
        <knowledgeGraph ref="knowledgeGraph" :key="refreshKey"></knowledgeGraph>
      </div>
      <moe-empty url="moe_empty_bg_img.png" emptyText="暂无数据" v-show="!isShowKnowledgeGraph"></moe-empty>
      <noWrongVue ref="noWrong" @goClassicsWrongConsolidate="goClassicsWrongConsolidate"></noWrongVue>
      <!-- <moe-empty url="development_icon_gray.png" emptyText="功能开发中，敬请期待"></moe-empty> -->
    </div>
  </div>
</template>

<script>
import noWrongVue from "@/components/popup/noWrong.vue";
import knowledgeGraph from "@/components/echarts/knowledgeGraph.vue";
import fiveStep from "./fiveStep.vue";
import { debounce } from "@/assets/utils/dbucTrtl";
import { mapState } from "vuex";
export default {
  name: "GjkcH5WrongQuestionAnalysis",

  components: {
    noWrongVue,
    knowledgeGraph,
    fiveStep,
  },
  computed: {
    ...mapState({
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
    }),
  },
  inject: ["practiceBack", "showWrongQuestion"],
  data() {
    return {
      listQuery: {
        courseId: "",
        chapterId: "",
        schemeId: "",
        roundId: "",
        phaseId: "",
      },
      knowledgeCountInfo: {},
      isShowKnowledgeGraph: false,
      refreshKey: 1,
      loading: {},
    };
  },

  mounted() {
    this.checkWrongStateStatus();
    this.getMyKnowledgeCount();
  },

  methods: {
    // 上一步（没有上一章节阶段）
    previoustep() {
      this.$store.commit("learning/setStudyPreviousStep", 4);
    },
    nextStep() {
      this.$store.commit("learning/setStudyStepInfo", 4);
    },
    // 获取错题巩固错题列表
    goWrongConsolidate() {
      this.listQuery = {
        courseId: "",
        chapterId: "",
        schemeId: "",
        roundId: "",
        phaseId: "",
      };
      this.listQuery.chapterId = this.selectLearningInfo.chapterId;
      this.listQuery.courseId = this.selectLearningInfo.courseId;
      this.listQuery.schemeId = this.selectLearningInfo.schemeId;
      this.listQuery.roundId = this.selectLearningInfo.roundId;
      this.listQuery.phaseId = this.selectLearningInfo?.id;
      this.goWrongQuestionTest(1, false, '错题巩固');
      // this.$Api.exam
      //   .getPhaseWrongQusetion(this.listQuery)
      //   .then((res) => {
      //     if (res.data.data.length == 0) {
      //       this.$refs.noWrong.noWrongShow = true;
      //     } else {
      //       this.goWrongQuestionTest(res.data.data,false,'错题巩固');
      //     }
      //   })
      //   .catch(() => {});
    },
    goWrongQuestionTest: debounce(
      function (type, flag, title) {
        this.loading = this.$Dialog.loading('错题数据加载中，请耐心等待...');
        // flag用于控制错题是经典错题还是错题巩固，数据接口返回数据格式不同。。。。。
        // this.showWrongQuestion(true, list,flag,false,title);
        if (type == 1) {
          this.listQuery.practiceType = 1; // 1=预热练习（纠错练习），2=正式纠错（纠错重做）
          this.$Api.exam
            .getUserPhaseWrongQuestion(this.listQuery)
            .then((res) => {
              if (res.data.data.paperContext?.length == 0) {
                this.$refs.noWrong.noWrongShow = true;
                this.loading.close();
                this.loading = {};
              } else {
                // this.goWrongQuestionTest(res.data.data, false, '错题巩固');
                this.showWrongQuestion(true, res.data.data, flag, false, title);
                this.loading.close();
                this.loading = {};
              }
            })
            .catch(() => {
              this.loading.close();
              this.loading = {};
            });
        } else if (type == 2) {
          this.$Api.exam.getClassicsWrongQuestion(this.selectLearningInfo.courseId, this.selectLearningInfo.schemeId, this.selectLearningInfo.roundId, this.selectLearningInfo?.id, this.selectLearningInfo.chapterId).then(res => {
            if (res.data.data.length == 0) {
              this.$Dialog.toast("该阶段暂无经典错题，请继续学习");
            } else {
              // this.goWrongQuestionTest(res.data.data, true, '经典错题');
              this.showWrongQuestion(true, res.data.data, flag, false, title);
            }
            this.loading.close();
            this.loading = {};
          }).catch(() => {
            this.loading.close();
            this.loading = {};
          })
        }
      },
      300,
      false
    ),
    // 经典错题
    goClassicsWrongConsolidate() {
      this.goWrongQuestionTest(2, true, '经典错题');
      // this.$Api.exam.getClassicsWrongQuestion(this.selectLearningInfo.courseId, this.selectLearningInfo.schemeId, this.selectLearningInfo.roundId, this.selectLearningInfo?.id, this.selectLearningInfo.chapterId).then(res => {
      //   if (res.data.data.length == 0) {
      //     this.$Dialog.toast("该阶段暂无经典错题，请继续学习");
      //   } else {
      //     this.goWrongQuestionTest(res.data.data, true, '经典错题');
      //   }
      // })
    },
    // 错题反思
    goWrongReflect() {
      this.$Dialog.toast('功能开发中', { type: 'warning' });
    },
    // 知识点统计结果
    getMyKnowledgeCount() {
      this.$Api.learning
        .getMyKnowledgeCount(
          this.selectLearningInfo.courseId,
          this.selectLearningInfo.schemeId,
          this.selectLearningInfo.roundId,
          this.selectLearningInfo?.id,
          this.selectLearningInfo.chapterId
        )
        .then((res) => {
          this.knowledgeCountInfo = res.data.data;
          this.knowledgeCountInfo.percentage =
            this.knowledgeCountInfo.percentage.filter(
              (item) => item.knowledgeName != ""
            );
          if (this.knowledgeCountInfo.percentage.length) {
            this.isShowKnowledgeGraph = true;
          } else {
            this.isShowKnowledgeGraph = false;
          }
          if (this.$refs.knowledgeGraph) {
            this.$refs.knowledgeGraph.chartOption.series[0].data =
              this.knowledgeCountInfo.percentage.map((item) => {
                return {
                  name: item.knowledgeName,
                  value: item.knowledgePercentage,
                  id: item.knowledgeId,
                  symbolSize: this.calculateNodeSize(item.knowledgeName),
                };
              });
          }
          // this.$refs.knowledgeGraph.show = true;
        })
        .catch(() => { });
    },
    // 同步纠错状态
    checkWrongStateStatus(){
      this.$Api.learning.checkWrongStateStatus({schemeChapterPhaseId:this.selectLearningInfo?.id}).then(()=>{

      }).catch(()=>{})
    },
    calculateNodeSize(nodeName) {
      const BASE_SIZE = 40;
      const CHAR_WIDTH = 12;  // 中文字符宽度估值
      const PADDING = 20;     // 左右内边距总和

      // 计算：直径 = 字符数×单字宽度 + 内边距
      let diameter = nodeName.length * CHAR_WIDTH + PADDING;

      // 限制在40-100px之间
      return Math.max(BASE_SIZE, Math.min(100, diameter));
    }
  },
};
</script>

<style lang="scss" scoped>
.exercise_consolidation {
  width: 762px;
  background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;
  font-size: 14px;
  color: #111111;

  .exercise-title {
    font-size: 18px;
    font-weight: 600;
  }

  .btn_next {
    width: 69px;
    height: 30px;
    line-height: 30px;
    background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
    border-radius: 18px;
    text-align: center;
    color: #fff;
  }

  .btn_previous {
    background: none;
    border: 1px solid #909090;
    color: #909090;
  }

  .homework_difficult {
    font-size: 12px;
    color: #999999;

    .line_green {
      width: 3px;
      height: 16px;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      border-radius: 4px;
    }

    .difficult_text {
      font-size: 14px;
      color: #111111;
    }
  }

  .stage_analysis {
    .stage_one {
      width: 349px;
      height: 86px;
      background: #f7faff;
      border-radius: 10px;
      padding: 13px 20px;
      box-sizing: border-box;

      .knowledge_total {
        width: 60px;
        height: 60px;
      }

      .stage_info {
        color: #111111;
        height: 60px;

        .stage_value {
          font-size: 24px;
          color: #111111;

          .stage_unit {
            font-size: 14px;
            color: #999999;
          }
        }
      }
    }
  }

  .practice_consolidate {
    .consolidate_one {
      width: 349px;
      height: 120px;
      border-radius: 10px;
      position: relative;
      font-size: 13px;
      color: #282c80;
      padding: 20px;
      box-sizing: border-box;

      .wrong_box_bg {
        width: 349px;
        height: 120px;
        position: absolute;
        top: 0;
        left: 0;
      }

      .consolidate_one_info {
        position: relative;
        font-weight: 600;
        font-size: 18px;
        color: #262b7f;
        z-index: 9;

        .next_page {
          width: 14px;
          height: 14px;
        }
      }

      .consolidate_text {
        position: relative;
        z-index: 9;
      }
    }

    .practice_consolidate_one {
      width: 230px;
      height: 110px;
      background: linear-gradient(180deg, #F6FAFF 0%, rgba(247, 247, 247, 0) 100%);
      border-radius: 10px;
      font-size: 12px;
      color: #303030;

      .exercise_consolidation_icon1 {
        width: 64px;
        height: 64px;
      }
    }
  }
}
</style>